module.exports = __webpack_public_path__ + "static/media/csv-contact.41c72001.svg";